import {
  apiRequest,
  apiRequestWithETag,
  apiDelete,
  safeApiCall,
  buildUrl,
  ApiResponse,
} from './client';

// Friend interfaces
export interface Friend {
  id: string;
  displayName: string;
  friendsSince: string;
}

export interface PaginatedFriendsResponse {
  items: Friend[];
  totalCount: number;
}

export interface GetFriendsOptions {
  search?: string;
  skip?: number;
  take?: number;
}

/**
 * Gets the current user's friends list (paginated, with optional search)
 */
export const getFriends = (options?: GetFriendsOptions): Promise<PaginatedFriendsResponse> =>
  safeApiCall(
    () => apiRequest<PaginatedFriendsResponse>(buildUrl('/api/friends', {
      search: options?.search,
      skip: options?.skip,
      take: options?.take,
    })),
    "Error fetching friends"
  );

/**
 * ETag-aware variant of `getFriends`.
 */
export const getFriendsWithETag = (
  options?: GetFriendsOptions,
  etag?: string | null
): Promise<ApiResponse<PaginatedFriendsResponse>> =>
  apiRequestWithETag<PaginatedFriendsResponse>(
    buildUrl('/api/friends', {
      search: options?.search,
      skip: options?.skip,
      take: options?.take,
    }),
    etag
  );

/**
 * Removes a friend
 */
export const removeFriend = (friendId: string): Promise<void> =>
  safeApiCall(
    () => apiDelete(buildUrl(`/api/friends/${encodeURIComponent(friendId)}`)),
    "Error removing friend"
  );
